import MarkdownRenderer from "./MarkdownRenderer";

const DocsIndex = () => <MarkdownRenderer filePath="index" />;

export default DocsIndex;
